export default __webpack_public_path__ + "static/media/MYSQL.df85aefe.svg";